
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  titulos: {
    alignSelf: 'flex-start',
    margin: '20px 0 0 20px',
    fontSize: 25,
    fontWeight: 500,
    color: '#5e6784',
    fontFamily: 'IBM Plex Sans',
    verticalAlign: 'center',
  },
  span: {
    fontSize: 12,
    fontWeight: 'normal',
  },
  backgroundBarraPesquisa: {
    backgroundImage: 'linear-gradient(278deg, #061f80, #0430ad)',
    width: '100%',
    height: 160,
    position: 'relative',
    marginBottom: 100,
  },
  quadradoEscuro: {
    width: 36,
    height: 36,
    backgroundColor: '#0430ad',
    position: 'absolute',
    right: 0,
    top: 0,
  },
  quadradoClaro: {
    width: 36,
    height: 36,
    backgroundColor: '#044ada',
    position: 'absolute',
    right: 36,
    top: 36,
  },
  barraFiltroDiv: {
    width: '100%',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'center',
    top: '70%',
  },
  barraFiltro: {
    width: '95%',
    backgroundColor: 'white',
    minHeight: 106,
    boxShadow: '0 2px 0 0 #dfdfe6',
    padding: 20,
    display: 'flex',
    alignItems: 'center',
    zIndex: 0,
    marginTop: 100,
    '& button': {
      width: '100%',
    }
  },
  tituloPagina: {
    fontFamily: 'IBM Plex Sans',
    fontSize: 49,
    fontWeight: 500,
    color: 'white',
    padding: 20,
  },
  textField: {
    flexBasis: 200,
  },
  inputBorda: {
    margin: 0,
    height: 42,
    border: 'solid 1px #c2c4d1!important',
    borderRadius: 4,
    backgroundColor: 'white',
    padding: 0,
  },
  select: {
    padding: 0,
    fontSize: 14,
    height: 42,
    backgroundColor: 'white',
  },
  botaoFiltrar: {
    minHeight: 42,
    borderRadius: 6,
    border: 'solid 1px #97c1ff',
    backgroundColor: 'white',
    color: '#044ada',
    textTransform: 'none',
    boxShadow: 'none',
    fontFamily: 'IBM Plex Sans',
    fontSize: 14,
    fontWeight: 500,

  },
  botaoLimparFiltros: {
    minHeight: 42,
    borderRadius: 6,
    border: 'none',
    backgroundColor: 'white',
    color: '#044ada',
    textTransform: 'none',
    boxShadow: 'none',
    fontFamily: 'IBM Plex Sans',
    fontSize: 14,
    fontWeight: 500,
    '&hover': {
      backgroundColor: 'inherit',
    },
  },
  grid: {
    display: 'flex',
    flexFlow: 'wrap',
  },
  titulo: {
    color: '#5e6784',
    fontFamily: 'IBM Plex Sans',
    fontSize: 25,
    fontWeight: 500,
    marginLeft: 20,
  },
  small: {
    fontSize: 12,
    fontWeight: 'normal',
    marginLeft: '10px',
  },

}));

export default useStyles;
